import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "../client";

/**
 * Mutations for the 360-page alias editor. Each one invalidates the
 * customer-360 query so the alias list re-renders with fresh data.
 */

function invalidateCustomer(qc: ReturnType<typeof useQueryClient>, id: string) {
  qc.invalidateQueries({ queryKey: ["crm", "customer360", id] });
}

export function useAddAlias(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) =>
      client
        .post(`/admin/customers/${customerId}/aliases`, {
          email,
          source: "manual",
        })
        .then((r) => r.data),
    onSuccess: () => invalidateCustomer(qc, customerId),
  });
}

export function useRemoveAlias(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (aliasId: string) =>
      client
        .delete(`/admin/customers/${customerId}/aliases/${aliasId}`)
        .then((r) => r.data),
    onSuccess: () => invalidateCustomer(qc, customerId),
  });
}

export function usePromoteAlias(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (aliasId: string) =>
      client
        .post(`/admin/customers/${customerId}/aliases/${aliasId}/promote`)
        .then((r) => r.data),
    onSuccess: () => invalidateCustomer(qc, customerId),
  });
}
